import { render, staticRenderFns } from "./UserDetailShareBonus.vue?vue&type=template&id=8849494e&"
import script from "./UserDetailShareBonus.vue?vue&type=script&lang=js&"
export * from "./UserDetailShareBonus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports